module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-items-image-05cbd97f729551df2ff23768497ebd42.png";